export const LICENSE_TYPE_OPTIONS = [
  { value: "PERMISSIVE", label: "license-type-options.permissive" },
  { value: "UNCATEGORIZED", label: "license-type-options.uncategorized" },
  { value: "COMMERCIAL", label: "license-type-options.commercial" },
  { value: "NON_COMMERCIAL", label: "license-type-options.non-commercial" },
  {
    value: "SOURCE_AVAILABLE",
    label: "license-type-options.source-available",
  },
  {
    value: "STRONG_COPYLEFT",
    label: "license-type-options.strong-copyleft",
  },
  { value: "WEAK_COPYLEFT", label: "license-type-options.weak-copyleft" },
];
export const SEVERITY_OPTIONS = [
  { value: "CRITICAL", label: "severity-options.critical" },
  { value: "HIGH", label: "severity-options.high" },
  { value: "MEDIUM", label: "severity-options.medium" },
  { value: "LOW", label: "severity-options.low" },
];

export const LICENSE_CATEGORY_OPTIONS = [
  { value: "PERMISSIVE", label: "license-category-options.permissive" },
  { value: "UNCATEGORIZED", label: "license-category-options.uncategorized" },
  { value: "COMMERCIAL", label: "license-category-options.commercial" },
  { value: "NON_COMMERCIAL", label: "license-category-options.non-commercial" },
  { value: "NON_LICENSE", label: "license-category-options.non-license" },
  {
    value: "SOURCE_AVAILABLE",
    label: "license-category-options.source-available",
  },
  {
    value: "STRONG_COPYLEFT",
    label: "license-category-options.strong-copyleft",
  },
  { value: "WEAK_COPYLEFT", label: "license-category-options.weak-copyleft" },
];

export const LICENSE_CATEGORY_OPTIONS_NO_TRANSLATION = [
  { value: "PERMISSIVE", label: "Permissive" },
  { value: "UNCATEGORIZED", label: "Uncategorized" },
  { value: "COMMERCIAL", label: "Commercial" },
  { value: "NON_COMMERCIAL", label: "None Commercial" },
  { value: "NON_LICENSE", label: "None License" },
  {
    value: "SOURCE_AVAILABLE",
    label: "Source Available",
  },
  {
    value: "STRONG_COPYLEFT",
    label: "Strong Copyleft",
  },
  { value: "WEAK_COPYLEFT", label: "Weak Copyleft" },
];

export const LICENSE_TYPE_OPTIONS_NO_TRANSLATION = [
  { value: "PERMISSIVE", label: "Permissive" },
  { value: "UNCATEGORIZED", label: "Uncategorized" },
  { value: "COMMERCIAL", label: "Commercial" },
  { value: "NON_COMMERCIAL", label: "None Commercial" },
  {
    value: "SOURCE_AVAILABLE",
    label: "Source Available",
  },
  {
    value: "STRONG_COPYLEFT",
    label: "Strong Copyleft",
  },
  { value: "WEAK_COPYLEFT", label: "Weak Copyleft" },
];
